import { useMemo } from 'react';
import { useLazyQuery } from '@apollo/client';
import ILT_QUERY from '../queries/ILT_QUERY';

const useILT = () => {
    const [ fetchILT, { data, loading, error } ] = useLazyQuery( ILT_QUERY );

    const iltData = useMemo( () => {
        return data?.instructorLedTraining ? data.instructorLedTraining : undefined;
    }, [ data ] );
    
    const loadILT = ( iltID ) => {
        const vars = {
            variables: {
                iltID
            }, 
            fetchPolicy: 'network-only' 
        };

        return fetchILT( vars );
    };

    return useMemo( () => {
        return {
            loadILT: loadILT,
            iltData,
            iltError: error,
            iltLoading: loading
        };
    }, [ fetchILT, iltData, error, loading ] );
};

export default useILT;
